<template>
  <div class="home">
    <LogoAnimation></LogoAnimation>
  </div>
</template>

<script>

import LogoAnimation from '../components/LogoAnimation'
export default {
  name: 'Home',
  components: {
    LogoAnimation
  }
}
</script>
<style lang="scss">
</style>
